import { type LoaderFunction, wordpressLoader, json, redirect, WpController, disk } from '@ubo/losse-sjedel'
import type { VacatureConnection } from '~/graphql/types'
import $page, { type PageLoaderData, middleware } from '~/templates/page'

// If the URL contains the vacancyNr we will redirect to the correct vacancy page
export const loader: LoaderFunction = async (data) => {
  try {
    let page = (await wordpressLoader(data)) as unknown as PageLoaderData

    await middleware(page, data.request)

    return json(page.body, page.headers)
  } catch (error) {
    const wpController = await WpController.init(data.request.url)
    wpController.setFlexData(data.context.flexData.flexContent, data.context.flexData.queries, data.context.flexData.postTypes)

    let response = (await disk.get(`vacancies`)) as unknown as { vacancies: VacatureConnection }

    if (!response) {
      response = await wpController.query(`{
        vacancies: vacatures(first: 999, where: {status: PUBLISH}) {
          nodes {
            uri
            recap {
              vacancyNr
            }
          }
        }
      }`)

      await disk.set(`vacancies`, response, 60 * 5)
    }

    const vacancy = response?.vacancies?.nodes?.find((vacancy) => vacancy.recap.vacancyNr === data.params.slug)

    if (!vacancy) {
      throw new Response('Not Found', {
        status: 404
      })
    }

    return redirect(vacancy.uri)
  }
}

export default $page
